import { ISortDropdownOption } from '../../components/SortDropdown/types';
import { ISortVariant } from '../../repositories/dailyrent/entities/sort_variant/SortVariant';

/**
 * Маппит варианты сортировки с ручки в опции дропдауна.
 * TSortKey выведен из EKey, поэтому variant.key присваивается без каста.
 */
export const getSortOptions = (sortVariants: ISortVariant[]): ISortDropdownOption[] =>
  sortVariants.map(variant => ({ key: variant.key, label: variant.value }));
